import { themeLight2, Theme } from '@redislabsdev/redis-ui-styles';

export const themeUi: Theme = themeLight2;
